import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Business = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Business Incorporations</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Navigate Business Incorporation with Confidence
          </h1>
          <p className="tax-section-description">
            Starting a business is an exciting venture, but the incorporation
            process can feel overwhelming. At <strong>Litax </strong>,
            we simplify business incorporations, providing step-by-step guidance
            to ensure you understand the benefits, requirements, and best
            structure for your business.
          </p>

          <h2 className="tax-subheading">Why Incorporate Your Business?</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Limited Liability Protection:</strong> Safeguard your
              personal assets from business debts and legal claims.
            </li>
            <li>
              <strong>Enhanced Credibility:</strong> An incorporated business
              appears more professional to clients, vendors, and investors.
            </li>
            <li>
              <strong>Tax Flexibility:</strong> Access deductions and benefits
              not available to sole proprietors or partnerships.
            </li>
            <li>
              <strong>Better Access to Capital:</strong> Raise funds more easily
              through shares or investors.
            </li>
          </ul>

          <h2 className="tax-subheading">How We Can Help</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Entity Selection:</strong> Guidance on choosing the right
              structure (Corporation, S-Corp, LLC, or Partnership).
            </li>
            <li>
              <strong>Name Availability:</strong> Assistance in securing a
              compliant and unique business name.
            </li>
            <li>
              <strong>Document Filing:</strong> Preparation and submission of
              Articles of Incorporation or Organization.
            </li>
            <li>
              <strong>EIN Assistance:</strong> Obtain your Employer
              Identification Number (EIN) for taxes and banking.
            </li>
            <li>
              <strong>Ongoing Compliance:</strong> Support with filings,
              record-keeping, and IRS obligations.
            </li>
            <li>
              <strong>Tax Strategy:</strong> Tailored planning to reduce tax
              liability and maximize savings.
            </li>
          </ul>

          <h2 className="tax-subheading">Take the First Step</h2>
          <p className="tax-section-description">
            At <strong>Litax </strong>, we make incorporation simple
            and stress-free. Partner with us to set your business on the path to
            success. <strong>Contact us today</strong> to schedule a
            consultation and start your incorporation journey with confidence!
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Business;
